import { useRefreshFile } from "#candidate/redux/actions"
import { useCandidateRedux } from "#candidate/redux/slice"
import {
	candidateFileTypeGet,
	candidateIdFileIdPut,
	candidateIdFilePost,
} from "#candidate/services/api"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import PERMISOS from "#constants/perfiles"
import { DialogMaster } from "#core/components/dialog/Dialog"
import InputFilePDF from "#core/components/input/file/InputFilePDF"
import InputSelect from "#core/components/input/select/InputSelect"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import { UseHasPermission } from "#hooks/useHasPermission"
import { Box } from "@mui/material"
import { useCallback, useMemo, useState } from "react"
import { toast } from "react-toastify"
import { CandidateFileTypeFormDialog } from "./CandidateFileTypeForm"

const initialValues = {
	type_file: "",
	file: null,
}
export const CandidateFileFormInitialValues = initialValues

export default function CandidateFileForm({ values, setValues, disabled }) {
	const [openType, setOpenType] = useState(false)
	const isRH = UseHasPermission(PERMISOS.RH)
	const [reload, setReload] = useState(false)
	const { data, error, loading } = useApi(candidateFileTypeGet, {
		autoFetch: true,
		reload,
	})

	const fileTypes = useMemo(() => {
		const types = data?.data || []
		return types.map((type) => {
			let label = type.name
			if (isRH)
				label = `${type.name} ${type.is_confidential ? "(Confidencial)" : ""} ${
					type.is_required ? "(Obligatorio)" : ""
				}`
			return { ...type, label }
		})
	}, [data?.data, isRH])

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
			<div style={{ display: "flex", justifyContent: "right", gap: "1rem" }}>
				<InputSelect
					label="Tipo de archivo"
					options={fileTypes}
					value={values.type_file}
					setValue={(e) => setValues((old) => ({ ...old, type_file: e }))}
					optionsId={"id"}
					optionsLabel={"label"}
					disabled={disabled}
				/>
				{/* {!values?.id && (
					<Tooltip title="Agregar tipo de archivo">
						<Button onClick={() => setOpenType(true)}>
							<AddBoxIcon />
						</Button>
					</Tooltip>
				)} */}
			</div>
			<InputFilePDF
				label="Seleccionar pdf"
				value={values.file}
				setValue={(value) => setValues((old) => ({ ...old, file: value }))}
			/>
			<CandidateFileTypeFormDialog
				{...{
					open: openType,
					setOpen: setOpenType,
					refresh: () => setReload((old) => !old),
				}}
			/>
		</Box>
	)
}

export const candidateFileFormValidation = (values) => {
	if (!values.type_file) {
		toast.error("El tipo de archivo es obligatorio")
		return false
	}
	if (!values.file) {
		toast.error("El archivo es obligatorio")
		return false
	}
	return true
}

export const CandidateFileFormDialog = ({ open, setOpen, data }) => {
	const { refresh } = useRefreshFile()
	const [values, setValues] = useState(data ?? initialValues)
	const [disabled, setDisabled] = useState(false)
	const { candidateId } = useCandidateRedux()

	const success = () => {
		setOpen(false)
		setValues(initialValues)
		refresh()
	}

	const end = () => {
		setDisabled(false)
	}

	const { fetch: fetchPut } = useApiSend(candidateIdFileIdPut, { success, end })
	const { fetch: fetchPost } = useApiSend(candidateIdFilePost, { success, end })

	const fetch = useMemo(() => {
		if (data?.id) return (values) => fetchPut(candidateId, data.id, values)
		return (values) => fetchPost(candidateId, values)
	}, [candidateId, data, fetchPost, fetchPut])

	const handleSubmit = useCallback(() => {
		if (!candidateFileFormValidation(values)) return
		setDisabled(true)

		let formData = new FormData()
		formData.append("type_file", values.type_file)
		formData.append("file", values.file)

		fetch(formData)
	}, [fetch, values])

	const handleClose = useCallback(() => {
		setOpen(false)
		setValues(initialValues)
	}, [setOpen])

	return (
		<DialogMaster
			{...{
				title: data?.id ? "Editar archivo" : "Agregar archivo",
				setOpen,
				open,
				handleSubmit,
				disabled,
				onClose: handleClose,
			}}
		>
			<CandidateFileForm {...{ values, setValues, disabled: !!data }} />
		</DialogMaster>
	)
}
